const SESSION_STORAGE_PREFIX = "@natura:natura-auth";

export const SESSION_STORAGE = {
  OTP_CONTEXT: `${SESSION_STORAGE_PREFIX}:otp-context`,
};
